var _path, _circle, _circle2, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.143 63H57.8571C56.5689 63 55.3335 63.5057 54.4226 64.4059C53.5117 65.3061 53 66.527 53 67.8V106.2C53 107.473 53.5117 108.694 54.4226 109.594C55.3335 110.494 56.5689 111 57.8571 111H116.143C117.431 111 118.666 110.494 119.577 109.594C120.488 108.694 121 107.473 121 106.2V67.8C121 66.527 120.488 65.3061 119.577 64.4059C118.666 63.5057 117.431 63 116.143 63ZM110.8 67.8L87 84.072L63.2 67.8H110.8ZM57.8571 106.2V69.984L85.6157 88.968C86.0222 89.2467 86.5052 89.3961 87 89.3961C87.4948 89.3961 87.9778 89.2467 88.3843 88.968L116.143 69.984V106.2H57.8571Z",
    fill: "#4A4A4A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 86.5,
    r: 83.5,
    stroke: "#CCCCCC",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 69,
    r: 14,
    fill: "#2D91E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115 55C112.231 55 109.524 55.8211 107.222 57.3594C104.92 58.8978 103.125 61.0843 102.066 63.6424C101.006 66.2006 100.729 69.0155 101.269 71.7313C101.809 74.447 103.143 76.9416 105.101 78.8995C107.058 80.8574 109.553 82.1908 112.269 82.731C114.984 83.2712 117.799 82.9939 120.358 81.9343C122.916 80.8747 125.102 79.0803 126.641 76.778C128.179 74.4757 129 71.7689 129 69C129 65.287 127.525 61.726 124.899 59.1005C122.274 56.475 118.713 55 115 55ZM115 81C112.627 81 110.307 80.2962 108.333 78.9776C106.36 77.6591 104.822 75.7849 103.913 73.5922C103.005 71.3995 102.768 68.9867 103.231 66.6589C103.694 64.3311 104.836 62.1929 106.515 60.5147C108.193 58.8365 110.331 57.6936 112.659 57.2306C114.987 56.7676 117.399 57.0052 119.592 57.9134C121.785 58.8217 123.659 60.3598 124.978 62.3332C126.296 64.3065 127 66.6266 127 69C127 72.1826 125.736 75.2348 123.485 77.4853C121.235 79.7357 118.183 81 115 81Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113 74.5L108 69.54L109.59 67.97L113 71.35L120.41 64L122 65.58L113 74.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedEmailIcon);
export default __webpack_public_path__ + "static/media/VerifiedEmailIcon.aeb8f3a32e00b60ac7db40c20bcafbf6.svg";
export { ForwardRef as ReactComponent };